// extracted by mini-css-extract-plugin
module.exports = {"root":"Columns_root__EEI0u","separator":"Columns_separator__AWW7C"};